import { Controller } from "@hotwired/stimulus"

// タブのリンクをクリックしたとき、現在の検索 input の値を q として URL に付与し、
// Turbo Frame `projects_section` の src を書き換えて部分更新する。
// ブラウザの URL は変えない。
export default class extends Controller {
  static targets = ["input"]
  static values = { frame: { type: String, default: "projects_section" } }

  navigate(event) {
    const link = event.currentTarget
    if (!link || !link.href) return

    event.preventDefault()
    const url = new URL(link.href, window.location.origin)
    const query = this.hasInputTarget ? this.inputTarget.value.trim() : ""
    if (query) {
      url.searchParams.set("q", query)
    } else {
      url.searchParams.delete("q")
    }
    const frame = document.getElementById(this.frameValue)
    if (frame) {
      frame.src = url.toString()
    }
  }
}
